import { defineMessages } from 'react-intl';

const productPageMessages = defineMessages({
  title: {
    id: 'products.title',
    defaultMessage: 'Products',
    description: 'Products page headline',
  },
  addProduct: {
    id: 'products.addProduct',
    defaultMessage: 'Add product',
    description: 'Products page add product button',
  },
  noProductsFound: {
    id: 'products.noProductsFound',
    defaultMessage: 'No products found for the current search query.',
    description: 'Products page no products found message',
  },
  noResults: {
    id: 'products.noResults',
    defaultMessage: 'No products have been created yet.',
    description: 'Products page no results message',
  },
  noResultsButton: {
    id: 'products.noResultsButton',
    defaultMessage: 'Create new Product',
    description: 'Products page no results button',
  },
  gridViewButton: {
    id: 'products.gridViewButton',
    defaultMessage: 'Grid view',
    description: 'Products page grid view button',
  },
  tableViewButton: {
    id: 'products.tableViewButton',
    defaultMessage: 'Table view',
    description: 'Products page table view button',
  },
  searchBarPlaceholder: {
    id: 'products.searchBarPlaceholder',
    defaultMessage: 'Search products',
    description: 'Products page search bar placeholder',
  },
  filterBarPlaceholder: {
    id: 'products.filterBarPlaceholder',
    defaultMessage: 'Filter products',
    description: 'Products page filter bar placeholder',
  },
  filterBarText: {
    id: 'products.filterBarText',
    defaultMessage: 'Show:',
    description: 'Products page filter bar text',
  },
  filterBarOptionAllProducts: {
    id: 'products.filterBarOptionAllProducts',
    defaultMessage: 'All products',
    description: 'Products page filter bar option all products',
  },
  filterBarOptionMyProducts: {
    id: 'products.filterBarOptionMyProducts',
    defaultMessage: 'My products',
    description: 'Products page filter bar option my products',
  },
});

const formValidationMessages = defineMessages({
  required: {
    id: 'form.validation.required',
    defaultMessage: '{fieldName} is required.',
    description: 'Form validation required message',
  },
  minimumLength: {
    id: 'form.validation.minimumLength',
    defaultMessage: 'Minimum of {minLength} characters long.',
    description: 'Form validation minimum length message',
  },
  maximumLength: {
    id: 'form.validation.maximumLength',
    defaultMessage: 'Maximum of {maxLength} characters long.',
    description: 'Form validation minimum length message',
  },
  invalidCharacters: {
    id: 'form.validation.invalidCharacters',
    defaultMessage: 'Entered characters are not allowed.',
    description: 'Form validation invalid characters message',
  },
});

const productFormTranslations = defineMessages({
  productGroupInputLabel: {
    id: 'products.productForm.productGroupInputLabel',
    defaultMessage: 'Product group',
    description: 'Product form product group input label',
  },
  productGroupInputPlaceholder: {
    id: 'products.productForm.productGroupInputPlaceholder',
    defaultMessage: 'Select product group',
    description: 'Product form product group input placeholder',
  },
  nameInputLabel: {
    id: 'products.productForm.nameInputLabel',
    defaultMessage: 'Product name',
    description: 'Product form name input label',
  },
  nameInputPlaceholder: {
    id: 'products.productForm.nameInputPlaceholder',
    defaultMessage: 'Enter product name',
    description: 'Product form name input placeholder',
  },
  descriptionInputLabel: {
    id: 'products.productForm.descriptionInputLabel',
    defaultMessage: 'Product description',
    description: 'Product form description input label',
  },
  descriptionInputPlaceholder: {
    id: 'products.productForm.descriptionInputPlaceholder',
    defaultMessage: 'Enter product description',
    description: 'Product form description input placeholder',
  },
  productTypeInputLabel: {
    id: 'products.productForm.productTypeInputLabel',
    defaultMessage: 'Product type',
    description: 'Product form product type input label',
  },
  productTypeInputPlaceholder: {
    id: 'products.productForm.productTypeInputPlaceholder',
    defaultMessage: 'Select product type',
    description: 'Product form product type input placeholder',
  },
  productVersionInputLabel: {
    id: 'products.productForm.productVersionInputLabel',
    defaultMessage: 'Product version',
    description: 'Product form product version input label',
  },
  productVersionInputPlaceholder: {
    id: 'products.productForm.productVersionInputPlaceholder',
    defaultMessage: 'Select product version',
    description: 'Product form product version input placeholder',
  },
  productProductIdentifierInputLabel: {
    id: 'products.productForm.productProductIdentifierInputLabel',
    defaultMessage: 'Product identifier',
    description: 'Product form product identifier input label',
  },
  productProductIdentifierInputPlaceholder: {
    id: 'products.productForm.productProductIdentifierInputPlaceholder',
    defaultMessage: 'Enter product identifier',
    description: 'Product form product identifier input placeholder',
  },
  productProjectIdentifierInputLabel: {
    id: 'products.productForm.productProjectIdentifierInputLabel',
    defaultMessage: 'Project identifier',
    description: 'Product form project identifier input label',
  },
  productProjectIdentifierInputPlaceholder: {
    id: 'products.productForm.productProjectIdentifierInputPlaceholder',
    defaultMessage: 'Enter project identifier',
    description: 'Product form project identifier input placeholder',
  },
  productTemplateSelectLabel: {
    id: 'products.productForm.productTemplateSelectLabel',
    defaultMessage: 'Tailoring Proposal',
    description: 'Product form template input label',
  },
  productTemplateSelectPlaceholder: {
    id: 'products.productForm.productTemplateSelectPlaceholder',
    defaultMessage: 'Choose Tailoring Proposal',
    description: 'Product form template input placeholder',
  },
  productTypeInputOptionSoftware: {
    id: 'products.productForm.productTypeInputOptionSoftware',
    defaultMessage: 'Software',
    description: 'Product form product type input option software',
  },
  productTypeInputOptionHardware: {
    id: 'products.productForm.productTypeInputOptionHardware',
    defaultMessage: 'Hardware',
    description: 'Product form product type input option hardware',
  },
  sumbitButton: {
    id: 'products.productForm.sumbitButton',
    defaultMessage: 'Submit',
    description: 'Product form submit button',
  },
  backButton: {
    id: 'products.productForm.backButton',
    defaultMessage: 'Cancel',
    description: 'Product form back button',
  },
});

const dialogTranslations = defineMessages({
  addProductTitle: {
    id: 'products.dialog.addProductTitle',
    defaultMessage: 'New product',
    description: 'Add product dialog title',
  },
  editProductTitle: {
    id: 'products.dialog.editProductTitle',
    defaultMessage: 'Edit product',
    description: 'Edit product dialog title',
  },
  retireProductTitle: {
    id: 'products.dialog.retireProductTitle',
    defaultMessage: 'Retire product',
    description: 'Retire product dialog title',
  },
  retireProductDescription: {
    id: 'products.dialog.retireProductDescription',
    defaultMessage:
      'You are about to retire Product {name}. This action is irreversible. Are you sure you want to proceed?',
    description: 'Retire product dialog description',
  },
  publishTemplateTitle: {
    id: 'products.dialog.publishTemplateTitle',
    defaultMessage: 'Publish Tailoring Proposal',
    description: 'Publish template dialog title',
  },
  publishTemplateDescription: {
    id: 'products.dialog.publishTemplateDescription',
    defaultMessage: 'You are about to publish Tailoring Proposal {name}. Are you sure you want to proceed?',
    description: 'Publish template dialog description',
  },
  privateTemplateTitle: {
    id: 'products.dialog.privateTemplateTitle',
    defaultMessage: 'Set Tailoring Proposal as private',
    description: 'Private template dialog title',
  },
  privateTemplateDescription: {
    id: 'products.dialog.privateTemplateDescription',
    defaultMessage: 'You are about to set Tailoring Proposal {name} as private. Are you sure you want to proceed?',
    description: 'Private template dialog description',
  },
});

const toastTranslations = defineMessages({
  addProductToast: {
    id: 'products.toast.add',
    defaultMessage: 'Product successfully added.',
    description: 'Add product toast message',
  },
  editProductToast: {
    id: 'products.toast.edit',
    defaultMessage: 'Product successfully edited.',
    description: 'Edit product toast message',
  },
  activateProductToast: {
    id: 'products.toast.activate',
    defaultMessage: 'Product successfully activated.',
    description: 'Activate product toast message',
  },
  retireProductToast: {
    id: 'products.toast.retire',
    defaultMessage: 'Product successfully retired.',
    description: 'Retire product toast message',
  },
  privateTemplateToast: {
    id: 'products.toast.private',
    defaultMessage: 'Tailoring Proposal successfully set as private.',
    description: 'Private template toast message',
  },
  publishTemplateToast: {
    id: 'products.toast.publish',
    defaultMessage: 'Tailoring Proposal successfully published.',
    description: 'Publish template toast message',
  },
  deleteProductToast: {
    id: 'products.toast.delete',
    defaultMessage: 'Product successfully deleted.',
    description: 'Delete product toast message',
  },
  excludeBuildingBlocksToast: {
    id: 'products.toast.excludeBuildingBlocks',
    defaultMessage: 'Building blocks excluded.',
    description: 'Exclude building blocks toast message',
  },
  includeBuildingBlocksToast: {
    id: 'products.toast.includeBuildingBlocks',
    defaultMessage: 'Building blocks included.',
    description: 'Include building blocks toast message',
  },
  excludeBuildingBlockToast: {
    id: 'products.toast.excludeBuildingBlock',
    defaultMessage: 'Building block excluded.',
    description: 'Exclude building block toast message',
  },
  includeBuildingBlockToast: {
    id: 'products.toast.includeBuildingBlock',
    defaultMessage: 'Building block included.',
    description: 'Include building block toast message',
  },
});

export { dialogTranslations, formValidationMessages, productFormTranslations, productPageMessages, toastTranslations };
